module.exports = __webpack_public_path__ + "static/media/settings-icon.8677a263.svg";